import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STRIPE_PACK_CHECKOUT = "https://buy.stripe.com/cNidR80Nh4WZf795fCco000";
export const STRIPE_RABIETAS_CHECKOUT = "https://buy.stripe.com/fZucN43Ztahj0cf8rOco001";
const WA_NUMBER = "34689490644";
export const waLink = (text) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
export const WA_PACK = waLink("Hola, quiero empezar el Pack Equipo en Calma de En Dos Mundos (39 €). ¿Me indicáis cómo acceder al taller?");
export const WA_RABIETAS = waLink("Hola, me interesa el taller independiente Rabietas: acompañar con límites para familias con peques de 2–3 años (19 €). ¿Me indicáis cómo pagar y acceder?");
export const WA_GUIDE = waLink("Hola, me gustaría recibir gratis la guía de los 7 pasos para cuidar la pareja durante la crianza y conocer Equipo en Calma.");
export const WA_CONSULTATION = waLink("Hola, estoy mirando los talleres de En Dos Mundos y tengo una duda antes de comprar. ¿Me podéis ayudar?");
export const WA_HELP = waLink("Hola, necesito ayuda con mi código de acceso al Pack Equipo en Calma");
export const WA_SESSION = waLink("Hola, quiero reservar una sesión privada");
export const registerCheckoutLead = (lead) => axios.post(`${API}/public/leads`, lead).then((response) => response.data);

export const trackLead = (consent, product = "Equipo en Calma") => {
  if (!consent?.marketing || typeof window.fbq !== "function") return;
  window.fbq("track", "Lead", { content_name: product });
};

export const trackWhatsAppClick = (location, consent, product = "Equipo en Calma") => {
  const properties = { cta_location: location, product };

  if (consent?.marketing && typeof window.fbq === "function") {
    window.fbq("trackCustom", "WhatsAppClick", properties);
  }
  if (consent?.analytics && window.__endosmundosPostHogInitialized && typeof window.posthog?.capture === "function") {
    window.posthog.capture("whatsapp_cta_click", properties);
  }
};

export const waDoubt = (buyer, code, day) => waLink(`Hola, soy ${buyer} (código ${code}). Tengo una duda sobre el día ${day} del reto: `);
export const SUPPORT_DAYS = 21;

export const PRICE = 39;
export const PRICE_RABIETAS = 19;
export const OLD_PRICE = 57;
export const SESSION_PRICE = 60;

const CODE_KEY = "alania_code";
export const getCode = () => localStorage.getItem(CODE_KEY);
export const setCode = (c) => localStorage.setItem(CODE_KEY, c);
export const clearCode = () => localStorage.removeItem(CODE_KEY);

const DEVICE_KEY = "alania_device";
export const getDeviceId = () => {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/-/g, "").slice(0, 32);
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
};

export const fetchPack = (code) => axios.post(`${API}/pack/access`, { code, device_id: getDeviceId() }).then((r) => r.data);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).join(" ");
  return "Algo ha fallado. Inténtalo de nuevo.";
};
